export const JSONUtilFactory = ({ JSON }: { JSON: JSON }) => {
  const parse = <T>(jsonString: string): T | null => {
    try {
      return JSON.parse(jsonString) as T;
    } catch (error) {
      console.error(`Error parsing JSON string: ${error}`);
      return null;
    }
  };

  const stringify = <T>(obj: T): string | null => {
    try {
      return JSON.stringify(obj);
    } catch (error) {
      console.error(`Error converting object to JSON string: ${error}`);
      return null;
    }
  };

  return {
    parse,
    stringify,
  };
};
